export function getSelectedBounds() {
    const selectedBounds = new URLSearchParams(window.location.search).get("selectedBounds");
    if (!selectedBounds)
        return null;
    const bounds = selectedBounds.split(",");
    const parsed = bounds.map(Number);
    if (parsed.some(isNaN))
        return null;
    return parsed;
}
